// ============================================
// BABIES — Toothpillow Baby + Toddler Program (beta)
// View:   app/views/pages/babies.html.slim
// Styles: app/assets/stylesheets/babies.scss
//
// This page is self-contained: no shared marketing utils, no
// Bootstrap, no jQuery. Every block below is a no-op if its markup is
// absent, and the page is fully readable and navigable with this file
// blocked — the box list, the FAQ and the age switcher are <details>
// elements, and the terms dialog has a :target fallback.
//
// The prototype also carried an order-form script. The order flow is a
// hosted Jotform now, so there is no form on the page and that block
// is deliberately not carried over.
// ============================================

document.addEventListener("DOMContentLoaded", function () {
  initPillars();
  initTerms();
  initAgeNav();
});

/* ---------- Six pillars ----------
   Below the mobile breakpoint the wheel artwork drops its printed
   callouts, and the slices over it become links that reveal that
   pillar's note. The notes ship visible so they are still readable
   with no JavaScript and so each slice link has somewhere to jump to;
   this takes over the reveal and hides the rest. */
function initPillars() {
  const slices = document.querySelectorAll(".baby-pillar-slice");
  const captions = document.querySelectorAll(".baby-pillar-caption");
  if (!slices.length || !captions.length) return;

  function selectPillar(id) {
    captions.forEach((caption) => {
      caption.hidden = caption.id !== id;
    });
    slices.forEach((slice) => {
      if (slice.getAttribute("href") === "#" + id) {
        slice.setAttribute("aria-current", "true");
      } else {
        slice.removeAttribute("aria-current");
      }
    });
  }

  captions.forEach((caption) => {
    caption.hidden = true;
  });

  slices.forEach((slice) => {
    slice.addEventListener("click", function (event) {
      event.preventDefault();
      selectPillar(this.getAttribute("href").substring(1));
    });
  });
}

/* ---------- Beta terms ----------
   The policy lives in this page rather than at a second URL, so #terms
   addresses it. The links are real fragment links; this upgrades them
   to a modal where <dialog> is supported and leaves the :target
   fallback in place where it is not. */
function initTerms() {
  const dialog = document.getElementById("terms");
  if (!dialog || typeof dialog.showModal !== "function") return;

  function setHash(hash) {
    if (!history.replaceState) return;
    history.replaceState(null, "", hash || location.pathname + location.search);
  }

  function openTerms(event) {
    if (event) event.preventDefault();
    if (!dialog.open) dialog.showModal();
    setHash("#terms");
  }

  document.querySelectorAll('a[href="#terms"]').forEach((opener) => {
    opener.addEventListener("click", openTerms);
  });

  dialog.addEventListener("close", function () {
    if (location.hash === "#terms") setHash("");
  });

  if (location.hash === "#terms") openTerms();
}

/* ---------- Age switcher ----------
   The dropdown is a <details>, so it already opens and closes on its
   own. This only adds what a <details> does not do and a menu is
   expected to: close on Escape, and close when the next click lands
   outside it. */
function initAgeNav() {
  const nav = document.querySelector(".baby-agenav");
  if (!nav) return;

  document.addEventListener("click", function (event) {
    if (nav.open && !nav.contains(event.target)) nav.open = false;
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || !nav.open) return;
    nav.open = false;
    const summary = nav.querySelector("summary");
    if (summary) summary.focus();
  });
}
